import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { IPcaIndexAgency } from "app/models/core/admin/masterTables";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";



@Component({
  selector: 'app-pcaIndexAgency',
  templateUrl: './pcaIndexAgency.component.html'
})

export class PcaIndexAgentComponent implements OnInit {

  currentTab = 0;
  data: IPcaIndexAgency;

  public form = new UntypedFormGroup({
    Agency: new UntypedFormControl(''),
    Index: new UntypedFormControl(''),
    Pca: new UntypedFormControl('')
  });
  constructor(public adminService: AdminService,
    public sharedService: SharedService) { };

  ngOnInit(): void {
    this.getPcaIndexAgency();

  }

  getPcaIndexAgency(){
    this.adminService.getPcaIndexAgency().subscribe(
      res => {
        this.data = res;
        this.form.patchValue({
          Agency: this.data.agency,
          Pca: this.data.pca,
          Index: this.data.index,
        });
        
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  savePcaIndexAgency(){
    if (this.form.dirty){
      this.data.agency = this.form.controls['Agency'].value;
      this.data.pca = this.form.controls['Pca'].value;
      this.data.index = this.form.controls['Index'].value;
      this.adminService.savePcaIndexAgency(this.data).subscribe(
        res => {
          this.data = res;
        },
        error => console.log('error', error),
        () => {
        }
      );
      }
  }

}
